import Component from '../../common/Component';
import SlideShow from '../../common/components/SlideShow';
import ItemList from '../../common/utils/ItemList';
import app from '../app';

/**
 * The `HeaderPrimary` component displays primary header controls. On the
 * default skin, these are shown just to the right of the forum title.
 */
export default class TopBanner extends Component {

  oninit(vnode) {
    super.oninit(vnode);
    this.hidden = false;
    this.webTopImgList = [];
    this.mobileTopImgList = [];
    this.getTopImageListData();
    this.getImageListData();
  }

  view() {
    return <div class='topBanner-content'>
      {this.getWebImg()}
      {this.getMobileImg()}
    </div>;
  }

  /**
   * Build an item list for the controls.
   *
   * @return {ItemList<import('mithril').Children>}
   */
  items() {
    const items = new ItemList();

    return items;
  }

  getWebImg() {
    if (this.webTopImgList.length == 0) return null;
    return (<div class='top_banner_container web'>
      <SlideShow slideName="top_banner" containerId="top_banner" imgList={this.webTopImgList} slideWidth={0} autoWidth={true}>
      </SlideShow>
    </div>);
  }
  getMobileImg() {
    if (this.mobileTopImgList.length == 0) return null;
    return (<div class='top_banner_container mobile'>
      <SlideShow slideName="top_banner1" containerId="top_banner1" imgList={this.mobileTopImgList} slideWidth={0} autoWidth={true}>
      </SlideShow>
    </div>);
  }

  getImageListData() {
    let data = app.adsbannerData;
    if (data) {
      let list = [];
      list = data.list.banner['mobile_forum_ad_1'];

      if (list) {
        this.mobileTopImgList = list;
      }
    }
  }

  getTopImageListData() {
    let data = app.adsbannerData;
    if (data) {
      let list = [];
      list = data.list.banner['forum_banner'];

      if (list) {
        this.webTopImgList = list;
      }
    }
  }
}
